import r from"util";var t=r.inspect;export{t as u};
//# sourceMappingURL=util.inspect.js.map
